import React from 'react'
import { aboutImage } from '../data/constant'
import { Link } from 'react-router-dom'

function About() {
    return (
        <div className="container-xxl py-5">
            <div className="container py-5 px-lg-5">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                        <p className="section-title text-secondary">About Us<span /></p>
                        <h1 className="mb-5">#1 Digital solution with 5 years of experience</h1>
                        <p className="mb-4">Welcome to DGM, where innovation meets excellence. Explore our comprehensive IT solutions tailored to empower your business. From cutting-edge software development to robust cybersecurity and seamless cloud integration, we&apos;re here to elevate your digital journey. Join us in shaping the future of technology.</p>
                        <div className="skill mb-4">
                            <div className="d-flex justify-content-between">
                                <p className="mb-2">App Developement</p>
                                <p className="mb-2">100%</p>
                            </div>
                            <div className="progress">
                                <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={100} aria-valuemin={0} aria-valuemax={100} />
                            </div>
                        </div>
                        <div className="skill mb-4">
                            <div className="d-flex justify-content-between">
                                <p className="mb-2">Talent on demand</p>
                                <p className="mb-2">100%</p>
                            </div>
                            <div className="progress">
                                <div className="progress-bar bg-secondary" role="progressbar" aria-valuenow={100} aria-valuemin={0} aria-valuemax={100} />
                            </div>
                        </div>
                        <div className="skill mb-4">
                            <div className="d-flex justify-content-between">
                                <p className="mb-2">Web Design &amp; Development</p>
                                <p className="mb-2">100%</p>
                            </div>
                            <div className="progress">
                                <div className="progress-bar bg-dark" role="progressbar" aria-valuenow={100} aria-valuemin={0} aria-valuemax={100} />
                            </div>
                        </div>
                        <Link to='/service' className="btn btn-primary py-sm-3 px-sm-5 rounded-pill mt-3">Read More</Link>
                    </div>
                    <div className="col-lg-6">
                        <img className="img-fluid wow zoomIn" data-wow-delay="0.5s" src={aboutImage} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About